import { useState } from 'react';
import { Typography, Select, Table, Tag, Empty, Card } from 'antd';
import { useQuery } from '@tanstack/react-query';
import type { ColumnsType } from 'antd/es/table';
import { api, type ContestStanding } from '../api/client';
import { fmtTaipei } from './article-list/status';

const columns: ColumnsType<ContestStanding> = [
  {
    title: '名次',
    dataIndex: 'place',
    width: 80,
    render: (p: number | null, _r, i) =>
      p ? <Tag color={p <= 3 ? 'gold' : 'default'}>第 {p} 名</Tag> : <span className="text-gray-400">#{i + 1}</span>,
  },
  {
    title: '作品',
    dataIndex: 'name',
    render: (name: string, r) => (
      <div className="flex items-center gap-3">
        {r.coverUrl ? (
          <img src={r.coverUrl} alt="" className="h-10 w-14 rounded object-cover" />
        ) : (
          <div className="h-10 w-14 rounded bg-gray-100" />
        )}
        <span className="font-medium text-gray-800">{name}</span>
      </div>
    ),
  },
  { title: '得票', dataIndex: 'votesCount', width: 90, align: 'right' },
  { title: '平均分', dataIndex: 'votesAverage', width: 90, align: 'right', render: (v: number) => v.toFixed(1) },
  { title: '讚', dataIndex: 'likes', width: 80, align: 'right' },
  { title: '瀏覽', dataIndex: 'views', width: 90, align: 'right' },
];

/** 比賽存檔（read-only）：選一場比賽，看名次榜。 */
export default function ContestArchivePage() {
  const [contestId, setContestId] = useState<string>();
  const contests = useQuery({ queryKey: ['contests'], queryFn: api.contests });
  const standings = useQuery({
    queryKey: ['contest-standings', contestId],
    queryFn: () => api.contestStandings(contestId!),
    enabled: !!contestId,
  });

  const list = contests.data?.items ?? [];
  const current = standings.data?.contest;

  return (
    <div>
      <div className="mb-4 flex flex-wrap items-end justify-between gap-3">
        <div>
          <Typography.Title level={4} className="!mb-0">
            照片投票比賽存檔
          </Typography.Title>
          <p className="m-0 text-sm text-gray-400">歷屆人氣投票名次（唯讀展示）</p>
        </div>
        <Select
          className="w-72"
          placeholder="選擇比賽"
          loading={contests.isLoading}
          value={contestId}
          onChange={setContestId}
          options={list.map((c) => ({
            value: c.id,
            label: `${c.name}（${c.entryCount} 件）`,
          }))}
        />
      </div>

      {!contestId ? (
        <Empty description="請先選擇一場比賽" />
      ) : (
        <Card
          title={current?.name ?? '名次榜'}
          extra={
            current?.dateFinish ? (
              <span className="text-xs text-gray-400">結束於 {fmtTaipei(current.dateFinish)}</span>
            ) : null
          }
        >
          <Table<ContestStanding>
            rowKey="id"
            size="middle"
            loading={standings.isLoading}
            columns={columns}
            dataSource={standings.data?.items ?? []}
            pagination={false}
          />
        </Card>
      )}
    </div>
  );
}
